import { lazy } from "react";

import { SolicitudLayout } from "../layouts/SolicitudLayout";
import Solicitud from "@features/Solicitud/pages/Solicitud";
import RutaProtegida from "@components/RutaProtegida.tsx";
import WhiteZone from "@components/WhiteZone";

const InfoGeneral = lazy(() => import("../subFeatures/InfoGeneral/pages/InfoGral"));
const PerfilCrediticio = lazy(() => import("../subFeatures/PerfilFinanciero/pages/PerfilCrediticio"));
const PerfilLegal = lazy(() => import("../subFeatures/PerfilLegal/pages/PerfilLegal"));
const Oferta = lazy(() => import("../subFeatures/Oferta/pages/Oferta"));
const DictamenLegal = lazy(() => import("../subFeatures/DictamenLegal/pages/Dictamen"));
const Expediente = lazy(() => import("../subFeatures/Expediente/pages/Expediente"));
const RiesgoIdentidad = lazy(() => import("../subFeatures/RiesgoIdentidad/pages/RiesgoIdentidad"));
const PldIntegral = lazy(() => import("../subFeatures/PldIntegral/pages/PldIntegral"));
const VisitaOcular = lazy(() => import("../subFeatures/VisitaOcular/pages/VisitaOcular"));
const RevisionControl = lazy(() => import("../subFeatures/RevisionControl/pages/RevisionControl"));
const Contractuales = lazy(() => import("../subFeatures/Contractuales/pages/Contractuales"));
const CarteraDispersion = lazy(() => import("../subFeatures/CarteraDispersion/pages/CarteraDispersion"));
const ResumenOperacion = lazy(() => import("../subFeatures/ResumenOperacion/pages/ResumenOperacion"));

export const solicitudRoutes = {
    element: <RutaProtegida />,
    children: [
        {
            Component: SolicitudLayout,
            path: "/solicitud",
            errorElement: <WhiteZone error />,
            children: [
                {
                    path: ":companyName/:id",
                    Component: Solicitud,
                    children: [
                        {
                            index: true,
                            Component: InfoGeneral,
                        },
                        { path: "perfil_financiero", Component: PerfilCrediticio },
                        { path: "perfil_legal", Component: PerfilLegal },
                        { path: "oferta", Component: Oferta },
                        { path: "dictamen_legal", Component: DictamenLegal },
                        { path: "expediente", Component: Expediente },
                        // { path: "validacion_crediticia", Component: ValidacionCrediticia },
                        { path: "riesgo_identidad", Component: RiesgoIdentidad },
                        { path: "pld_integral", Component: PldIntegral },
                        { path: "visita_integral", Component: VisitaOcular },
                        { path: "revision_control", Component: RevisionControl },
                        { path: "contractuales", Component: Contractuales },
                        { path: "cartera_dispersion", Component: CarteraDispersion },
                        { path: "resumen", Component: ResumenOperacion },
                    ],
                },
            ],
        },
    ],
};
